import { render } from "./RoleProfilePicker.vue?vue&type=template&id=021cefa5&scoped=true&ts=true"
import script from "./RoleProfilePicker.vue?vue&type=script&lang=ts"
export * from "./RoleProfilePicker.vue?vue&type=script&lang=ts"

import "./RoleProfilePicker.vue?vue&type=style&index=0&id=021cefa5&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021cefa5"]])

export default __exports__